import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    rightGrid: {
        color: "#fff",
        paddingLeft: 10,
        paddingRight : 10,
        paddingBottom : 10,
        paddingTop : 30,
        backgroundColor: "#2c5fcb",
        borderStyle: 'solid',
        borderRadius: 10 ,
        textAlign : 'center'
    } ,
    leftGrid : {
        color: "#fff",
        padding: 10,
        borderStyle: 'solid',
        borderRadius: 5
    } ,
    logo : {
        width : 50 ,
        borderRadius : '50%' ,
        marginBottom : 20
    }
}))
